import { NameCell, NameHeader, NameColumnId } from './name-column';
import { QuantityCell, QuantityHeader, QuantityColumnId } from './quantity-column';

export const columns = [
  {
    header: NameHeader,
    accessor: NameColumnId,
    cell: NameCell,
    width: 2,
  },
  {
    header: QuantityHeader,
    accessor: QuantityColumnId,
    cell: QuantityCell,
    width: 1,
  },
];
